import {
  GET_ORDER_HISTORY_REQUEST,
  GET_ORDER_HISTORY_SUCCESS,
  SET_ORDER_HISTORY_MODAL_VISIBLE,
} from './orderHistoryTypes';
import api from '../../api';
import flattenProduct from '../../utils/flattenProduct';
import calculatePrice from '../../utils/calculatePrice';
import {
  getAvailablePastOrderedProducts,
  combinedSelectedProduct,
} from './utils/handleCompareProducts';
import { addComboToCart } from '../Cart/cartActions';
import {
  modifiedOrderedComboForSumarry,
  getModifiedCombo,
} from './utils/handleCompareCombos';
import { mapProductData } from '../Combo/comboActions';
import {
  getProducts,
  editComboInCart,
  updateShortageMessageInOrderAgainCombos,
  addNoConfigRequiredProductToCombo,
} from '../Combo/comboActions';
import { createAlert } from '../Alert/alertActions';
import { getOldItem } from './utils/handleCompareProducts';
import { getComboGroupUnavailableItems } from './utils/handleCompareCombos';
export function getOrderHistory() {
  return function(dispatch) {
    dispatch({ type: GET_ORDER_HISTORY_REQUEST });
    api.get(`/orders`).then((response) => {
      dispatch({
        type: GET_ORDER_HISTORY_SUCCESS,
        orderHistory: response.data.data,
      });
    });
  };
}
export function setOrderHistoryModalIsVisible(isVisible) {
  return function(dispatch) {
    dispatch({ type: SET_ORDER_HISTORY_MODAL_VISIBLE, isVisible: isVisible });
  };
}
export function addProductsToCart(
  products,
  setToastMessage,
  isReordering = false
) {
  return function(dispatch, getState) {
    const menuProducts = getState().menuReducer.products;
    products.map((product) => {
      const foundProduct = menuProducts.find(
        (menuProduct) => menuProduct?.product_id === product?.product_id
      );
      if (foundProduct) {
        let flatProduct = flattenProduct({
          ...product,
          prices: foundProduct.prices,
          options: product.options || [],
        });
        dispatch({
          type: 'ADD_TO_CART',
          product: {
            isEditing: false,
            isFromPreviousOrder: true,
            isFromReorderButton: product?.isFromReorderButton,
            requestGetProductToConfigure: false,
            selectedVariantId: flatProduct?.variant_id,
            flatProduct: flatProduct,
            ...calculatePrice(flatProduct, isReordering),
          },
        });
        if (products.length === 1 && setToastMessage) {
          setToastMessage(`${product.name} added to cart`);
        }
      }
    });
  };
}
export const addPastComboToCart = (
  pastOrderedCombo,
  isFromAllOrders = false
) => {
  return (dispatch) => {
    const businessId = parseInt(localStorage.getItem('business_id'));
    const orderedComboItemGroupIDs = pastOrderedCombo.combo_item_groups.reduce(
      (acc, cur) => {
        const selectedProduct = cur.combo_items.find((item) => item.product);
        if (selectedProduct) {
          acc.push(cur.combo_item_group_id);
        }
        return acc;
      },
      []
    );
    let localShortageMessage = {
      messageTopic: '',
      messageEnd: '',
      itemShortageMessages: [],
    };
    // find ordered products IDs
    const orderedProducts = pastOrderedCombo.combo_item_groups.reduce(
      (acc, cur) => {
        const selectedComboItem = cur.combo_items.find(
          (comboItem) => comboItem.product
        );
        if (selectedComboItem) {
          acc.push({
            ...selectedComboItem.product,
            combo_item_group_id: cur.combo_item_group_id,
          });
        }
        return acc;
      },
      []
    );
    const promises = orderedProducts.map((product) =>
      api.get(
        `/products/${product.product_id}?business_id=${businessId}&include=options&variant_id=${product.variant_id}&default_customization=false`,
        {
          ignore_interception: true,
        }
      )
    );
    return Promise.allSettled(promises)
      .then((response) => {
        const fulfilledResponses = response.filter(
          (res) => res.status === 'fulfilled'
        );
        const currentProducts = fulfilledResponses.map(
          (res) => res.value.data.data
        );
        return api
          .get(`/combos/${pastOrderedCombo.id}?business_id=${businessId}`)
          .then((comboResponse) => {
            const currentCombo = JSON.parse(
              JSON.stringify(comboResponse.data.data)
            );
            getProducts(currentCombo, businessId).then((products) => {
              let modifiedCombo = getModifiedCombo(
                currentCombo,
                orderedProducts,
                currentProducts,
                products
              );
              const comboWithUnavailable = getComboGroupUnavailableItems(
                orderedProducts,
                modifiedCombo
              );

              // getOldItem
              dispatch({
                type: 'GET_COMBO_SUCCESS',
                combo: comboWithUnavailable,
                comboCustomizerIsVisible: false,
              });

              // check errors
              // check extra combo item group error
              const foundExtraComboItemGroups = modifiedCombo.combo_item_groups.find(
                (item) =>
                  !orderedComboItemGroupIDs.includes(item.combo_item_group_id)
              );
              if (foundExtraComboItemGroups)
                localShortageMessage = {
                  ...localShortageMessage,
                  itemShortageMessages: [],
                  messageTopic:
                    'This combo has been changed.Please review the selection.',
                };
              // check product shourtage error
              const productShortages = modifiedCombo.combo_item_groups.reduce(
                (acc, curr, index) => {
                  if (
                    !curr.productCustomizer ||
                    (curr.productCustomizer &&
                      !curr.productCustomizer.selectedProduct
                        .is_product_available)
                  ) {
                    acc = {
                      ...acc,
                      messageTopic: `The following product is currently unavailable in ${curr.label}:`,
                      messageEnd: 'Select other available options below.',
                    };
                    if (orderedProducts[index]) {
                      acc.itemShortageMessages.push(
                        orderedProducts[index].name
                      );
                    }
                  }
                  return acc;
                },
                localShortageMessage
              );
              // update error object
              if (isFromAllOrders) {
                if (foundExtraComboItemGroups) {
                  dispatch(
                    updateShortageMessageInOrderAgainCombos(
                      localShortageMessage
                    )
                  );
                } else if (productShortages.messageTopic) {
                  dispatch(
                    updateShortageMessageInOrderAgainCombos(productShortages)
                  );
                }
                dispatch(
                  addComboToCart({
                    combo: comboWithUnavailable,
                    comboIndexInCart: undefined,
                    isEditing: false,
                  })
                );
              } else {
                if (foundExtraComboItemGroups) {
                  dispatch(
                    updateShortageMessageInOrderAgainCombos(
                      localShortageMessage
                    )
                  );
                  dispatch(editComboInCart(comboWithUnavailable, 0, false));
                } else if (productShortages.messageTopic) {
                  dispatch(
                    updateShortageMessageInOrderAgainCombos(productShortages)
                  );
                  dispatch(editComboInCart(comboWithUnavailable, 0, false));
                } else {
                  dispatch(
                    addComboToCart({
                      combo: comboWithUnavailable,
                      comboIndexInCart: undefined,
                      isEditing: false,
                    })
                  );
                }
              }
            });
          })
          .catch((e) => {
            dispatch(
              createAlert({
                type: 'error',
                message: "There's an error while loading combo.",
              })
            );
          });
      })
      .catch();
  };
};
export function reorderAll(pastProducts, pastCombos, setToastMessage) {
  const businessId = parseInt(localStorage.getItem('business_id'));
  return function(dispatch, getState) {
    // Products
    if (pastProducts.length > 0) {
      // const pastOrderedProductIDs = pastProducts.map(
      //   (product) => product.product_id
      // );
      // const promises = pastOrderedProductIDs.map((id) =>
      //   api.get(
      //     `/products/${id}?business_id=${businessId}&include=options&default_customization=true`,
      //     {
      //       ignore_interception: true,
      //     }
      //   )
      // );
      // return Promise.allSettled(promises).then((response) => {
      //   const fulfilledResponses = response.filter(
      //     (res) => res.status === 'fulfilled'
      //   );
      //   const currentProducts = fulfilledResponses.map(
      //     (res) => res.value.data.data
      //   );
      //   const combinedProducts = getAvailablePastOrderedProducts(
      //     pastProducts,
      //     currentProducts
      //   );
      // });
      const modifiedProducts = pastProducts.map((product) => {
        return { ...product, isFromReorderButton: true };
      });
      dispatch(addProductsToCart(modifiedProducts, setToastMessage, true));
    }
    // Combos
    if (pastCombos.length > 0) {
      let modifiedPastOrderedCombos = [];
      pastCombos.forEach((combo, i) => {
        // const addCombo = {
        //   combo: modifiedOrderedComboForSumarry(combo, businessId),
        //   comboIndexInCart: i,
        //   isEditing: false,
        // };
        // // addComboToCart(addCombo);
        // modifiedPastOrderedCombos.push(addCombo);
        dispatch(addPastComboToCart(combo, true));
      });
      // modifiedPastOrderedCombos.forEach((comboData) => {
      //   dispatch(addComboToCart(comboData));
      // });
    }
  };
}
